/* 1, not 0.5: a half star as the floor read as a near-zero "mistake" score,
   so every entry method (tap, scrub, click, keyboard) bottoms out at 1. */
export const MIN_RATING = 1;
export const MAX_RATING = 5;

/**
 * Quantise a horizontal position across the star strip (0 = left edge,
 * 1 = right edge) to a half-star score in [MIN_RATING, MAX_RATING].
 */
export const positionToHalfStarScore = (fraction: number): number => {
  const raw = Math.ceil(fraction * MAX_RATING * 2) / 2;
  return Math.min(MAX_RATING, Math.max(MIN_RATING, raw));
};

/** "3" for whole scores, "3.5" for halves. */
export const formatRatingScore = (score: number): string =>
  Number.isInteger(score) ? String(score) : score.toFixed(1);
